import { EventPhase } from '@angular/core/primitives/event-dispatch';

/**
 * During SSR hydration event replay (`withEventReplay()`), Angular replays the
 * original browser events after they have already been dispatched. Calling
 * `preventDefault` on such a replayed event has no effect and Angular throws
 * `preventDefault called during event replay.`. Guard against it by only calling
 * `preventDefault` when the event is not being replayed.
 */
const isEventReplay = (event: Event): boolean => event.eventPhase === EventPhase.REPLAY;

export const stopPropagation = (event: Event): false => {
  if (event) {
    if (!isEventReplay(event)) {
      event.preventDefault();
    }
    event.stopPropagation();
  }
  return false;
};

export const stopImmediatePropagation = (event: Event): false => {
  if (event) {
    if (!isEventReplay(event)) {
      event.preventDefault();
    }
    event.stopImmediatePropagation();
  }
  return false;
};
